// src/portal-app/tabs/tabCss.js
//
// ONE stylesheet for the five tab landings. Kept separate from the kit's
// pk-* sheet because these are screen-level layout rules, not reusable
// components — but injected the same way.
//
// Idempotency uses the DOM tag as the single source of truth rather than a
// module-level boolean, which can outlive the tag it tracks. This matches
// shell/kit/kitCss.js and differs deliberately from shell/LiquidGlass.js.
const CSS = `
.tab-wrap{width:100%;max-width:680px;margin-inline:auto;box-sizing:border-box;
  padding-block:4px 8px;}
.tab-title{font-size:28px;font-weight:800;color:var(--c-ink);
  letter-spacing:-.6px;padding-inline:16px;margin-block:4px 2px;}
.tab-sub{font-size:13px;font-weight:500;color:var(--c-textLight);
  padding-inline:16px;margin-block-end:14px;}
.tab-group{padding-inline:16px;margin-block-end:12px;}
.tab-locked-hint{font-size:11px;font-weight:600;color:var(--c-green);
  white-space:nowrap;}
.tab-empty{margin-inline:16px;padding:32px 20px;text-align:center;
  display:flex;flex-direction:column;align-items:center;gap:10px;}
.tab-empty-icon{color:var(--c-mutedLight);}
.tab-empty-title{font-size:15px;font-weight:800;color:var(--c-ink);}
.tab-empty-msg{font-size:13px;font-weight:500;color:var(--c-textLight);
  line-height:1.5;max-width:280px;}
.tab-empty-cta{font-size:12.5px;font-weight:700;color:var(--c-green);}

/* ---- shared loading skeleton ---- */
.tab-skel{margin-inline:16px;border-radius:20px;
  background:color-mix(in srgb,var(--c-ink) 6%,transparent);
  position:relative;overflow:hidden;margin-block-end:12px;}
.tab-skel::after{content:'';position:absolute;inset:0;
  background:linear-gradient(90deg,transparent,
    color-mix(in srgb,var(--c-surface) 55%,transparent),transparent);
  animation:tabShimmer 1.3s infinite;}
@keyframes tabShimmer{100%{transform:translateX(100%);}}

/* ---- shared error / retry ---- */
.tab-state{margin-inline:16px;padding:28px 20px;text-align:center;
  display:flex;flex-direction:column;align-items:center;gap:10px;}
.tab-retry{min-height:44px;padding-inline:20px;border-radius:999px;border:none;
  background:var(--c-green);color:var(--c-white);font-family:inherit;
  font-size:14px;font-weight:700;cursor:pointer;
  transition:transform .12s ease;}
.tab-retry:active{transform:scale(.97);}

@media (prefers-reduced-motion: reduce){
  .tab-skel::after{animation:none;}
  .tab-retry,.tab-retry:active{transition:none;transform:none;}
}
`;

export function ensureTabCss() {
    if (typeof document === 'undefined') return;
    if (document.getElementById('tab-css')) return;
    const tag = document.createElement('style');
    tag.id = 'tab-css';
    tag.textContent = CSS;
    document.head.appendChild(tag);
}

export default ensureTabCss;
